export default __webpack_public_path__ + "images/Taruvi_transparent.040c61f16fee3d8d5da0ed872daac0cf.png";